import React from "react";
import "./QuestionsFaq.css";
import QuestionsCcordion from "./QuestionsCcordion";
import FormLogo from "../assets/images/form-logo.png";

const QuestionsFaq = () => {
  return (
    <div className="questions-section">
    <div className="faq__container">
      <div className="questions-content-bar">
      <div className="question-title-bar">
        <div className="question-title">
          Frequently<br /> Asked <br />Questions
        </div>
        <p className="title-question-ptag">Many queries of yours<br /> solve here only</p>
        <div className="myeqaution-link"><a href="https://www.myequation.in/" target="_blank">www.myequation.in</a></div>
      </div>
      <div className="overview-content">
        <div className="faq questions">
          <div className="faq__question-container">
            <QuestionsCcordion
              title={"Who is this program for?"}
              text={"Whether you’re a beginner curious about AI or a professional looking to upskill, Robo AI offers hands-on learning experiences for all levels."}
              index={0}
            />
            <QuestionsCcordion
              title={"Do I need coding experience to start?"}
              text={"Not necessarily! We start with basics and guide you through Python and AI fundamentals step-by-step, so you can learn even if you’ve never coded before."}
            />
            <QuestionsCcordion
              title={"Can Robo AI help me in career transitions?"}
              text={"Definitely. Our mentors and resources are designed to help you build practical AI skills, boost your confidence, and open up career opportunities in tech and AI fields.."}
            />
            <QuestionsCcordion
              title={" Will I get to work on real-world projects?"}
              text={"Yes, you’ll build end-to-end AI models and mini-projects that simulate industry challenges — perfect for your resume or portfolio."}
            />
            <QuestionsCcordion
              title={"Will I get personal mentorship?"}
              text={"Absolutely! Our mentors are industry professionals who provide personalized feedback, help with projects, and guide your learning path."}
            />
          </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default QuestionsFaq;
